export default __webpack_public_path__ + "static/media/delete-icon-active.c128b1cd.svg";